import { useMemo } from 'react';
import { useSymbolStore } from '@/stores/symbol';
import Selector from '../common/selector';
import type { IconProps } from '../icons/icon.type';
import SmileIcon from '../icons/smile-icon';
import StickerIcon from '../icons/sticker-icon';

const SymbolSelector = () => {
  const selectedSymbol = useSymbolStore((s) => s.selectedSymbol);

  const symbols = useMemo(
    () => [
      {
        slug: 'emoji',
        item: <SmileIcon />,
      },
      {
        slug: 'sticker',
        item: <StickerIcon />,
      },
    ],
    [],
  );

  const select = (symbol: string) => {
    useSymbolStore.getState().setSelectedSymbol(symbol as 'emoji' | 'sticker');
  };

  return (
    <Selector<IconProps>
      className='mt-auto'
      items={symbols}
      itemProps={{
        svgClass: 'size-8',
      }}
      selected={selectedSymbol}
      onSelect={(slug) => select(slug)}
    />
  );
};

export default SymbolSelector;
